import { Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage";
import References from "./pages/References";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  return (
    <>
      <ScrollToTop />
      
      <Routes>
        <Route index element={<Home />} />
        <Route path="/references" element={<References />} />
      </Routes>
    </>
  );
}

export default App;
